export default __webpack_public_path__ + "static/media/loading-icon.0c238a17.gif";